import { Box, Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import EditorToolbar from "../editors/EditorToolbar";
import Switch from "../elements/Switch";

const BannersTable = ({
  banners,
  onBannerClick,
  onAddBanner,
  includeInactive,
  onIncludeInactiveChange,
}) => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <EditorToolbar onAdd={onAddBanner} />
        <Switch
          label="Include inactive banners"
          value={Boolean(includeInactive)}
          onChange={(newValue) => onIncludeInactiveChange(Boolean(newValue))}
        />
      </Box>
      {!banners || banners.length === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography
            variant="body2"
            color="text.secondary"
          >
            No banners found
          </Typography>
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Name (French)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {banners.map((banner) => (
                <TableRow
                  key={banner.id}
                  onClick={() => onBannerClick(banner.id)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                  }}
                >
                  <TableCell>{banner.name}</TableCell>
                  <TableCell>{banner.name_fr || ""}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default BannersTable;
